import {
  ApplicationConfig,
  isDevMode,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners
} from '@angular/core';
import { withRouterConfig } from '@angular/router';
import { initializeApplication } from './shared/provider/app-state-provider/initialize-app';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MsalService,
  MsalGuard,
  MsalBroadcastService
} from '@azure/msal-angular';
import { providePrimeNG } from 'primeng/config';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient, withFetch, withInterceptors
} from '@angular/common/http';
import { headerInterceptor } from './core/interceptors/header.interceptor';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { appRoutes } from './app.routes';
import { appStateReducer } from './shared/provider/app-state-provider/state/state';
import { AppEffects } from './shared/provider/app-state-provider/effects/app.effects';
import { AdminAuthEffects } from './core/auth/store/auth.effects';
import { velocityTheme } from './core/themes/velocity';
import { provideI18n } from './core/i18n/i18n.config';
import {
  msalGuardConfig,
  msalInstance,
  msalInterceptorConfig
} from './core/auth/config/msal';
import { MessageService } from 'primeng/api';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    providePrimeNG({ theme: { ...velocityTheme } }),
    provideRouter(appRoutes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
    provideHttpClient(withFetch(), withInterceptors([headerInterceptor])),
    provideStore({ appState: appStateReducer }),
    provideEffects(AppEffects, AdminAuthEffects),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
    }),
    provideAppInitializer(initializeApplication),
    provideI18n(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.serviceWorkerEnabled,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    {
      provide: MSAL_INSTANCE,
      useValue: msalInstance,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useValue: msalGuardConfig,
    },
    {
      provide: 'MSAL_INTERCEPTOR_CONFIG',
      useValue: msalInterceptorConfig,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    MessageService,
  ],
};
